module.exports = __webpack_public_path__ + "static/media/advisoryboard1.c279bed5.jpg";